import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import { detectLocale } from "@/config/locale-domains"
import ro from "@/locales/ro.json"
import hu from "@/locales/hu.json"
import marketingRo from "@/locales/marketing-ro.json"
import marketingHu from "@/locales/marketing-hu.json"
import appUiRo from "@/locales/app-ui-ro.json"
import appUiHu from "@/locales/app-ui-hu.json"

// app-ui-*.json uses objects under app.dashboard, app.clients, etc. for page copy.
// Sidebar labels must use app.nav.* (see app-ui-ro.json) — not app.dashboard strings from ro.json.

function deepMerge(target, source) {
  const out = { ...target }
  for (const key of Object.keys(source)) {
    if (
      source[key] &&
      typeof source[key] === "object" &&
      !Array.isArray(source[key]) &&
      target[key] &&
      typeof target[key] === "object" &&
      !Array.isArray(target[key])
    ) {
      out[key] = deepMerge(target[key], source[key])
    } else {
      out[key] = source[key]
    }
  }
  return out
}

i18n.use(initReactI18next).init({
  resources: {
    ro: { translation: deepMerge(deepMerge(ro, marketingRo), appUiRo) },
    hu: { translation: deepMerge(deepMerge(hu, marketingHu), appUiHu) },
  },
  lng: detectLocale(),
  fallbackLng: "ro",
  interpolation: { escapeValue: false },
})

export default i18n
